import { Flex } from "@chakra-ui/react";
import { TimelinePlayer } from "components/TimelinePlayer/TimelinePlayer";
import { useRadarTimelineData } from "hooks/useRadarTimelineData";

import { observer } from "mobx-react-lite";
import { useStores } from "stores/setup/use-store";
import TimelineRadarSlider from "./TimelineRadarSlider";

export const TimelineRadarContainer = observer(() => {
  const {
    dataStores: { radarMapStore },
  } = useStores();

  const timelineProps = useRadarTimelineData();

  if (!timelineProps) return null;

  if (!timelineProps.allFrames.length) return null;

  if (!radarMapStore.showRadar) return null;

  return (
    <TimelinePlayer {...timelineProps}>
      <Flex align="center" w="100%" pr={4}>
        <TimelineRadarSlider
          totalFrames={timelineProps.totalFrames}
          currentIndex={timelineProps.currentIndex}
          pastLength={timelineProps.pastLength}
          nowcastLength={timelineProps.nowcastLength}
          timeMarkers={timelineProps.timeMarkers}
          elapsedTime={timelineProps.elapsedTime}
          isNowcast={timelineProps.isNowcast}
          onChange={(index: number) => timelineProps.onChangeIndex(index)}
          onClick={timelineProps.productAnalyticsEvent}
        />
      </Flex>
    </TimelinePlayer>
  );
});
